import {
	Dispatch,
	Action
} from 'redux';
// Import services
import {
	StringService,
} from '@app/services';
// Import enumerations.
import ActionType from '@app/redux/actions/types';
import {
	NotificationType,
} from '@app/enumerations';
// Import api models.
import {
	PossibleCorrespondenceType,
} from '@app/models/api';
// Import controller factory.
import ControllerFactoryProvider from '@app/controllers/factory';
// Import action methods.
import {
	addNotification,
	endProcessing,
	startProcessing,
} from '@app/redux/actions/methods';
// Import action parameters.
import {
	OverlayTargetParameters,
} from './ActionParametersBarrel';


// Load Possible Correspondence Type Action.

interface LoadPossibleCorrespondenceTypesAction extends Action {
	possibleCorrespondenceTypes: PossibleCorrespondenceType[];
}

type LoadPossibleCorrespondenceTypesParameters = OverlayTargetParameters;

const loadPossibleCorrespondenceTypesAction: (possibleCorrespondenceTypes: PossibleCorrespondenceType[]) =>
	LoadPossibleCorrespondenceTypesAction = (possibleCorrespondenceTypes: PossibleCorrespondenceType[]) => ({
		possibleCorrespondenceTypes: possibleCorrespondenceTypes,
		type: ActionType.LOAD_POSSIBLE_CORRESPONDENCE_TYPES,
	});

const loadPossibleCorrespondenceTypes = (params: LoadPossibleCorrespondenceTypesParameters) =>
	async (dispatch: Dispatch): Promise<PossibleCorrespondenceType[]> => {
		// Generate message id.
		const messageId: string = `${StringService.getInstance().hashObject(params)}-loadPossibleCorrespondenceTypes`;
		try {
			// Start processing.
			await startProcessing({
				message: 'Loading  correspondence types...',
				messageId: messageId,
				overlayTarget: params.overlayTarget,
			})(dispatch);
			// Call api to load possible correspondence types.
			let possibleCorrespondenceTypes: PossibleCorrespondenceType[] = await ControllerFactoryProvider.getControllerFactory().getPolicyNoteController().getPossibleCorrespondenceTypeOptions();
			// Load possible correspondence types to redux.
			dispatch<LoadPossibleCorrespondenceTypesAction>(loadPossibleCorrespondenceTypesAction(possibleCorrespondenceTypes));
			// End processing.
			await endProcessing({
				messageId: messageId,
				overlayTarget: params.overlayTarget,
			})(dispatch);

			return possibleCorrespondenceTypes;
		}
		catch (error: any) {
			// Add error notification.
			await addNotification({
				title: 'Error',
				primaryMessage: error.message,
				secondaryMessage: error.systemMessage,
				notificationType: NotificationType.ERROR,
			})(dispatch);
			// End processing.
			await endProcessing({
				messageId: messageId,
				overlayTarget: params.overlayTarget,
			})(dispatch);
			// Throw error;
			throw error;
		}
	};

// Export actions.
export {
	LoadPossibleCorrespondenceTypesAction,
};

// Export action methods.
export {
	loadPossibleCorrespondenceTypes,
};

// Export action parameters.
export {
	LoadPossibleCorrespondenceTypesParameters,
};

// Export action factories.
export {
	loadPossibleCorrespondenceTypesAction,
};